import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMiljogebyrKlagebehandlingVedtak } from "../../../../actions/miljogebyrerActions";
import Klagebehandlinginformasjon from "../../Detalj/Klagebehandlinginformasjon";

export default function KlagebehandlingInformasjonContainer({ miljogebyrId }) {
  const miljogebyrKlagebehandlingVedtak = useSelector(
    (state) => state.miljogebyrKlagebehandlingVedtak
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (miljogebyrId) dispatch(getMiljogebyrKlagebehandlingVedtak(miljogebyrId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Klagebehandlinginformasjon vedtak={miljogebyrKlagebehandlingVedtak} />;
}

KlagebehandlingInformasjonContainer.propTypes = {
  miljogebyrId: PropTypes.string,
};
